import { createErrors } from '@libs/common-next';

export type Page = 'StoreDetails';
export type Component = 'StoreDetailsServicesModule';

export const SentryErrors = createErrors<Page, Component>('StoreDetails')({
    StoreDetailsServicesModule: {
        InvalidVeterinaryCareUrl: {
            severity: 'MEDIUM',
            message: 'Invalid veterinaryCareUrl received from CommerceTools',
        },
    },
});
